import React, { Component } from "react";
import { Wrapper, Scroll, Copy, Bold } from "app/NativeComponents/common";

import Brackets from "./Brackets";

class BracketsHelper extends Component {
  render() {
    return (
      <Wrapper
        style={{
          backgroundColor: this.props.colors.card_color,
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: this.props.colors.border_color,
          margin: 10,
          borderRadius: 5
        }}
      >
        <Copy
          style={{
            padding: 10,
            paddingBottom: 0
          }}
        >
          <Bold>Press an option to insert it into the end of your text:</Bold>
        </Copy>

        <Scroll horizontal={true} keyboardShouldPersistTaps={"always"}>
          <Brackets {...this.props} />
        </Scroll>
      </Wrapper>
    );
  }
}

export default BracketsHelper;
